const BUSINESS_ADMIN_URL = process.env.REACT_APP_SERVICE_BACKEND_URL;
const BUSINESS_ADMIN_PORT = process.env.REACT_APP_SERVICE_BACKEND_PORT;

export const BUSINESS_ADMIN_HOST = `${BUSINESS_ADMIN_URL}:${BUSINESS_ADMIN_PORT}/business-admin`;

export const BILLING_COUPON_URL = `${BUSINESS_ADMIN_HOST}/v1/billing-coupons`;
export const ACTIVITY_LOG_URL = `${BUSINESS_ADMIN_HOST}/v1/logs`;
export const BUSINESSES_URL = `${BUSINESS_ADMIN_HOST}/v1/businesses`;
export const BANKS_URL = `${BUSINESS_ADMIN_HOST}/v1/banks`;
export const CONFIG_URL = `${BUSINESS_ADMIN_HOST}/v1/configurations/billings`;
export const CONFIG_LOG_URL = `${BUSINESS_ADMIN_HOST}/v1/configurations/logs`;
export const FORCE_ACTIVATION_URL = `${BUSINESS_ADMIN_HOST}/v1/businesses/identities/force-activate`;
export const DISCOUNT_BLACKLIST_URL = `${BUSINESS_ADMIN_HOST}/v1/discounts/blacklist`;
export const DISCOUNT_SETTINGS_URL = `${BUSINESS_ADMIN_HOST}/v1/discounts/settings`;
export const DISCOUNT_BOTTOM_PRICE_URL = `${BUSINESS_ADMIN_HOST}/v1/discounts/bottom-price`;
